import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { IExtsvcServerSettings } from '../../../ServerApi/types/IEditableServerSettings';

export type IGetExtsvcServerSettingsResult = IResult & IExtsvcServerSettings;

export class GetExtsvcServerSettingsRequest extends TagRequest<{}, IGetExtsvcServerSettingsResult> {
  constructor() {
    super('analyticsextensions', 'getAnalyticsExtensionsServerSettings', {});
  }
}
